import React from "react";
import { Navigate } from "react-router-dom";
import { authService } from "../api/services";

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    return <Navigate to="/patient-login" replace />;
  }

  return children;
};

export default ProtectedRoute; 